import { FC } from "react";
import { Icon } from "../../../../core/components/atoms/Icon";
import { Tag } from "../../../../core/components/atoms/Tag";
import { getDisciplineName } from "../../../../core/utils/new_discipline";
import { searchFilterStore } from "../../stores/searchFilters";
import { getFilterType } from "../../utils";

interface IRenderTagsContainerProps {
  callback: () => void;
}

export const RenderTagsContainer: FC<IRenderTagsContainerProps> = ({ callback }) => {
  const { 
    removeDisciplineSearch, 
    removeCategorySearch, 
    disciplineSearch, 
    categorySearch 
  } = searchFilterStore();

  const handleRemove = (item: string, type: 'discipline' | 'category') => {
    if (type === 'discipline') {
      removeDisciplineSearch(item);
    } else {
      removeCategorySearch(item);
    }

    callback();
  };

  if(disciplineSearch.length === 0 && categorySearch.length === 0) {
    return null;
  }

  return (
    <div id='filterTagsSearch' className='flex w-full flex-row flex-wrap gap-xs'> 
      {disciplineSearch.map((it, i) => (
        <Tag
          variant='primary'
          key={i}
          className='flex flex-row items-center gap-sm px-2'
        >
          {getDisciplineName(it)}
          <Icon
            Icon='close'
            type='material'
            className='cursor-pointer text-sm'
            onClick={() => handleRemove(it, 'discipline')}
          />
        </Tag>
      ))}
      {categorySearch.map((it, i) => (
        <Tag
          variant='primary'
          key={i}
          className='flex flex-row items-center gap-sm px-2'
        >
          {getFilterType(it)}
          <Icon
            Icon='close'
            type='material'
            className='cursor-pointer text-sm'
            onClick={() => handleRemove(it, 'category')}
          />
        </Tag>
      ))}
    </div>
  );
};